import ajax from 'common/ajax';
import config from 'site-config';

export function getLiveDetail(params: Record<string, string>) {
    return ajax.get(config.API.getLiveDetail, {
        params
    }).then(resp => {
        if (resp.data && resp.data.code === 0) {
            return resp.data.data;
        }
    }).catch(err => {
        console.error(err);
    });
}

export function getTimSign(params?: { uid: string }) {
    return ajax.get(config.API.getIMToken, {
        params
    }).then(resp => {
        if (resp.data && resp.data.code === 0) {
            return resp.data.data?.token;
        }
    }).catch(err => {
        console.error(err);
    });
}